import React from "react";
import { Box, Typography, Grid2 } from "@mui/material";
import WhoAreWe from "../assets/images/whoarewe.webp";
import { Theme } from "../Theme";
import { ThemeProvider } from "@mui/material/styles";

export default function AboutUs() {
  return (
    <ThemeProvider theme={Theme}>
      <Box
        sx={{
          minHeight: "100vh", // Ensure full viewport height
          background: "linear-gradient(135deg, #001d32 30%, #004080 100%)", // Gradient background
          color: "white",
          padding: "40px 20px", // Add consistent padding
          display: "flex",
          flexDirection: "column",
          alignItems: "center", // Center all items horizontally
        }}
      >
        <Grid2
          sx={{
            maxWidth: "1200px", // Limit content width for better readability
            width: "100%",
            textAlign: "centre",
            marginBottom: "40px",
            justifyContent: "center",
          }}
        >
          <Typography variant="h1">About Us</Typography>
          <Typography variant="body1" sx={{ opacity: 0.8 }}>
            Learn more about our mission and vision to create impactful
            solutions.
          </Typography>
        </Grid2>

        <Grid2
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Flex layout for small screens (column) and larger screens (row)
            alignItems: "center", // Center content vertically
            justifyContent: "center", // Center content horizontally
            maxWidth: "1200px",
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
          }}
        >
          {/* Image */}
          <img
            src={WhoAreWe}
            alt="Who We Are"
            style={{
              width: "100%",
              maxWidth: "300px", // Ensure the image size is manageable
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
              marginBottom: "20px", // Margin for spacing on mobile
            }}
          />

          {/* Text */}
          <Grid2
            sx={{
              marginLeft: { md: "20px" },
              textAlign: "justify",
              maxWidth: "900px",
            }}
          >
            <Typography variant="h1">Who We Are</Typography>
            <Typography variant="body1">
              We are a dynamic and multidisciplinary team of experts
              specializing in network infrastructure, data science, and business
              operations. Our diverse skillsets, honed through years of industry
              experience, position us at the forefront of technological
              innovation and operational excellence. By staying ahead of market
              trends and leveraging cutting-edge tools, we deliver
              transformative solutions that address the unique needs of modern
              businesses.
            </Typography>
          </Grid2>
        </Grid2>

        {/** Section: Mission */}
        <Grid2
          sx={{
            maxWidth: "1200px",
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            textAlign: "justify",
            marginBottom: "20px",
          }}
        >
          <Typography variant="h1">Our Mission</Typography>
          <Typography variant="body1">
            Our mission is to empower organizations globally by providing
            innovative, data-driven solutions that address their most pressing
            challenges. Through a combination of cutting-edge technology, deep
            industry expertise, and a commitment to excellence, we design and
            implement network infrastructure, data science strategies, and
            optimized business processes. We believe in helping our clients
            adapt to the ever-changing digital landscape, unlocking their
            potential and creating sustainable growth.
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, marginTop: "20px" }}>
            We strive to be a trusted partner, building long-term relationships
            and ensuring our clients’ success. Our solutions are tailored to
            meet the unique needs of each organization, regardless of industry,
            size, or geographical location. Our mission is not just about
            technology – it’s about using technology as a means to drive real
            impact and meaningful change in the world.
          </Typography>
        </Grid2>

        {/** Section: Vision */}
        <Grid2
          sx={{
            maxWidth: "1200px",
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
            textAlign: "justify",
          }}
        >
          <Typography variant="h1">Our Vision</Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Our vision is to be recognized as a global leader in delivering
            transformative digital solutions that drive innovation, improve
            operational efficiency, and enable sustainable growth for businesses
            of all sizes. We envision a future where every organization,
            regardless of industry or location, can leverage the power of
            technology to unlock new opportunities, streamline their operations,
            and enhance their competitiveness.
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, marginTop: "20px" }}>
            We believe that the future of business lies in embracing digital
            transformation – one that integrates intelligent technologies like
            AI, data analytics, and IoT seamlessly into everyday business
            operations. Our vision is not only about advancing technology but
            also about helping companies create lasting, positive impacts on
            society, their employees, and their customers. Our goal is to build
            a world where innovation is at the core of every business strategy,
            ensuring a smarter, more sustainable future for all.
          </Typography>
        </Grid2>
      </Box>
    </ThemeProvider>
  );
}
